import React, { useEffect, useState } from "react";
import { Auth } from "aws-amplify";
import axios from "axios";
import { Routes, Route, Navigate } from "react-router-dom";
import { AlertTitle, CircularProgress, Divider, List, ListItem } from "@mui/material";
import { useTranslation } from 'react-i18next';

import MuiAlert from '@mui/material/Alert';

import Dashboard from "./Dashboard"
import Organizations from "./Organizations";

const MasterAdminContent = () => {
  const [masterAdminInfo, setMasterAdminInfo] = useState("")
  const [error, setError] = useState(false)
  const [errorMsg, setErrorMsg] = useState([])

  const { t } = useTranslation();

  useEffect(() => {
    Auth.currentSession()
    .then((data) => {
      const jwtToken = data.idToken.jwtToken;
      const cognitoUsername = data.idToken.payload["cognito:username"];

      const getExpInfo = async() => {
        try {
          const response =  await axios.get("https://zk1128nq2f.execute-api.ap-south-1.amazonaws.com/alpha/masterAdmin/"+cognitoUsername, {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': jwtToken
            }
          });
          setMasterAdminInfo(response.data)
          // console.log(response.data)
          // if(response.data.allTests){
          //   setMasterAdminInfo(response.data)
          // }
          // else{
          //   setError(true)
          //   setErrorMsg(["TEST_NOT_FOUND", "No test has been completed"])
          // }
        }
        catch (error) {
          setError(true)
          setErrorMsg([error.code, error.message])
          console.log(error)
        }
      }

      getExpInfo()
    })
    .catch((err) => console.log(err));
    
  }, []);

  return (
    <div className="content">
        { masterAdminInfo
          ?
          <>
            {/* {masterAdminInfo.notification &&
              <div style={{display: "flex", backgroundColor: "rgb(255, 244, 229)", padding: "6px 12px", borderRadius: "6px"}}>
                <p style={{fontSize: "14px", color: "rgb(102, 60, 0)"}}> <b>Info:</b> {masterAdminInfo.notification}</p>
              </div>          
            } */}
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/organizations" element={<Organizations masterAdminInfo={masterAdminInfo}/>} />
              <Route path="*" element={<Navigate to="/"/>} />
            </Routes>
          </>
          :
          <div className="blankScreen">
            {error 
              ?
              <MuiAlert severity="warning" className="blankScreenError" sx={{borderRadius: "10px"}}>
                <AlertTitle><h3>{t("commonItems.error_network_label")}:</h3></AlertTitle>
                  <Divider/>
                  <List>
                    <ListItem disableGutters><h3>{t("commonItems.error_network_line1")}</h3></ListItem>
                    <ListItem disableGutters>
                      <p>{t("commonItems.error_network_line2")} <span></span>
                        <a href="https://forms.gle/fnU48UpGWWs5zgoT6" target="_blank" rel="noopener noreferrer" style={{color: "rgb(25, 118, 210)", textDecoration: "underline", textUnderlinePosition: "under"}}>
                          {t("commonItems.error_network_line2_formLinkLabel")}
                        </a>
                      </p>
                      </ListItem>
                    {errorMsg && 
                      <ListItem disableGutters>
                        <p>
                          {t("commonItems.error_network_response", {code: errorMsg[0], msg: errorMsg[1]})}
                        </p>
                      </ListItem>
                    }
                  </List>
              </MuiAlert>
              :
              <CircularProgress color="info"/>
            }
          </div>
        }
    </div>
  )
};

export default MasterAdminContent;
